import React from 'react';
import Button from '../../../components/ui/Button';
import { formatDate } from '../../../utils/dateUtils';

const LeadActionPanel = ({ leadStatus, leadData, onEdit, onDownloadPDF, onContactSupport }) => {
  const canEdit = ['Submitted', 'Under Review']?.includes(leadStatus);

  return (
    <div className="bg-card rounded-lg border border-border elevation-1 p-6 sticky top-24">
      <h3 className="text-lg font-semibold text-foreground mb-4">Actions</h3>
      
      <div className="space-y-3">
        {canEdit && (
          <Button
            variant="default"
            fullWidth
            iconName="Edit"
            iconPosition="left"
            onClick={onEdit}
          >
            Edit Lead
          </Button>
        )}
        
        
        <Button
          variant="outline"
          fullWidth
          iconName="MessageCircle"
          iconPosition="left"
          onClick={onContactSupport}
        >
          Contact Support
        </Button>
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-semibold text-foreground mb-3">Quick Info</h4>
        <div className="space-y-2 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Last Updated</span>
            <span className="text-foreground font-medium">{formatDate(leadData?.updatedAt)}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-muted-foreground">Auto-refresh</span>
            <span className="text-success font-medium flex items-center gap-1">
              <span className="w-2 h-2 bg-success rounded-full animate-pulse"></span>
              Active
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadActionPanel;